// src/router.js
import { createRouter, createWebHistory } from 'vue-router';
import HomePage from './views/HomePage.vue';
import AboutPage from './views/AboutPage.vue';
import PlatformPage from './views/PlatformPage.vue';
import SmartOnboardingDownload from './views/SmartOnboardingDownload.vue';
import AcspTrainingVideo from './views/AcspTrainingVideo.vue';
import MarkerDemoVideo from './views/MarkerDemoVideo.vue';
import ResourcesPage from './views/ResourcesPage.vue';
import CDDChecklistDownload from './views/CDDChecklistDownload.vue';
import BOToolkitDownload from './views/BOToolkitDownload.vue';

// International Hub Pages
import UAEHub from './views/UAEHub.vue';
import USHub from './views/USHub.vue';
import AustraliaHub from './views/AustraliaHub.vue';
import CanadaHub from './views/CanadaHub.vue';

// International Download Pages
import UAEDownload from './views/UAEDownload.vue';
import USDownload from './views/USDownload.vue';
import AustraliaDownload from './views/AustraliaDownload.vue';
import AustraliaAmlCtfDownload from './views/AustraliaAmlCtfDownload.vue';
import CanadaDownload from './views/CanadaDownload.vue';
import CanadaM2BoDownload from './views/CanadaM2BoDownload.vue';

// UK Additional Resources
import ProfessionalEnablementDownload from './views/ProfessionalEnablementDownload.vue';
import SoFSoWPosterDownload from './views/SoFSoWPosterDownload.vue';

// Australia Smart Onboarding International
import AustraliaSmartOnboardingDownload from './views/AustraliaSmartOnboardingDownload.vue';

// Australia Month 2 Beneficial Ownership Checklist & Cases
import AustraliaM2BoDownload from './views/AustraliaM2BoDownload.vue';

// UAE Month 2 Beneficial Ownership Verification Toolkit
import UAEBoDownload from './views/UAEBoDownload.vue';

// US NY 2026 AML Checklist
import USNyAmlDownload from './views/USNyAmlDownload.vue';

const routes = [
  // UK / Default
  { path: '/', component: HomePage },
  { path: '/about', component: AboutPage },
  { path: '/the-platform', component: PlatformPage },
  { path: '/resources', component: ResourcesPage },
  { path: '/smart-onboarding-download', component: SmartOnboardingDownload },
  { path: '/cdd-compliance-checklist', component: CDDChecklistDownload },
  { path: '/bo-verification-toolkit', component: BOToolkitDownload },
  { path: '/professional-enablement', component: ProfessionalEnablementDownload },
  { path: '/sof-sow-checklist-poster', component: SoFSoWPosterDownload },
  { path: '/acsp-training-video', component: AcspTrainingVideo },
  { path: '/marker-demo-video', component: MarkerDemoVideo },

  // UAE
  { path: '/uae', component: UAEHub },
  { path: '/uae/cdd-effectiveness-checklist', component: UAEDownload },
  { path: '/uae/beneficial-ownership-verification-toolkit', component: UAEBoDownload },

  // US
  { path: '/us', component: USHub },
  { path: '/us/aml-checklist', component: USDownload },
  { path: '/us/ny-2026-aml-checklist', component: USNyAmlDownload },

  // Australia
  { path: '/australia', component: AustraliaHub },
  { path: '/australia/aml-readiness-checklist', component: AustraliaDownload },
  { path: '/australia/aml-ctf-2026-readiness-checklist', component: AustraliaAmlCtfDownload },
  { path: '/australia/smart-onboarding', component: AustraliaSmartOnboardingDownload },
  { path: '/australia/beneficial-ownership-checklist', component: AustraliaM2BoDownload },

  // Canada
  { path: '/canada', component: CanadaHub },
  { path: '/canada/aml-aide-memoire', component: CanadaDownload },
  { path: '/canada/beneficial-ownership-verification-toolkit', component: CanadaM2BoDownload },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
